module.exports = __webpack_public_path__ + "img/icon6.bef149d7.png";